import axios from 'axios';
import { message } from 'antd';
import localStorage from "../../../utils/localStorage";

export const configurationCall = async () => {
  const token = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'GET',
    url: `/api/digitaltwins/get?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(header)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err && err.response && (err.response.status === 400 || err.response.status === 500)) {
        message.error(err.response.data.message);
      }
    });
};

export const MastersTypeData = async () => {
  const token = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'POST',
    url: `/api/masterConfiguration/getDropdown?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data: {
      TableName: "master.\"Master_ModuleTypes\"",
      ColumnName: "Module_Type"
    }
  };
  return axios(header)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err && err.response && (err.response.status === 400 || err.response.status === 500)) {
        message.error(err.response.data.message);
      }
    });
};

export const createConfiguration = async (payload) => {
  const token = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'POST',
    url: `/api/digitaltwins/create?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data: payload
  };
  return axios(header)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err && err.response && (err.response.status === 400 || err.response.status === 500)) {
        message.info(err.response.data.message);
      }
    });
};

export const updateConfiguration = async (payload) => {
  const token = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'PATCH',
    url: `/api/digitaltwins/update?SiteId=${siteId}&Id=${payload.id}`,
    headers: {
      Authorization: Authorization
    },
    data: payload
  };
  return axios(header)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err && err.response && (err.response.status === 400 || err.response.status === 500)) {
        message.error(err.response.data.message);
      }
    });
};

export const deleteConfiguration = async (payload) => {
  const token = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'DELETE',
    url: `/api/digitaltwins/delete?SiteId=${siteId}&Id=${payload}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(header)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err && err.response && (err.response.status === 400 || err.response.status === 500)) {
        message.error(err.response.data.message);
      }
    });
};

export const ModelData = async (payload) => {
  const token = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'POST',
    url: `/api/digitaltwins/getModal?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data: payload
  };
  return axios(header)
  .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err && err.response && (err.response.status === 400 || err.response.status === 500)) {
        message.info(err.response.data.message);
      }
    });
};

export const configurationData = async (data) => {
  const token = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'GET',
    url: `/api/digitaltwins/get?SiteId=${siteId}&Name=${data.Name}&Type=${data.Type}`,
    headers: {
      Authorization: Authorization
    },
  };
  return axios(header)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err && err.response && (err.response.status === 400 || err.response.status === 500)) {
        message.info(err.response.data.message);
      }
    });
};

export const assetConfigurationData = async (item1,item2) => {
  const token = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'GET',
    url: `/api/digitaltwins/get?SiteId=${siteId}&Name=${item2}&Type=${item1}`,
    headers: {
      Authorization: Authorization
    },
  };
  return axios(header)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err && err.response && (err.response.status === 400 || err.response.status === 500)) {
        message.info(err.response.data.message);
      }
    });
};

export const MastersKeyData = async (data) => {
  const token = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'POST',
    url: `/api/masterConfiguration/getDropdown?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data: {
      TableName: "master.\"Master_Elements\"",
      ColumnName: "Element",
      Conditions: [
        {
          key: "Module_Type",
          value: data.Type
        }
      ]
    }
  };
  return axios(header)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err && err.response && (err.response.status === 400 || err.response.status === 500)) {
        message.info(err.response.data.message);
      }
    });
};

export const assetMastersKeyData = async (data) => {
  const token = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'POST',
    url: `/api/masterConfiguration/getDropdown?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data: {
      TableName: "master.\"Master_Elements\"",
      ColumnName: "Element",
      Conditions: [
        {
          key: "Module_Type",
          value: data
        }
      ]
    }
  };
  return axios(header)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err && err.response && (err.response.status === 400 || err.response.status === 500)) {
        message.info(err.response.data.message);
      }
    });
};

export const configurationName = async (data) => {
  const token = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'GET',
    url: `/api/digitaltwins/getNamesByType?SiteId=${siteId}&Type=${data}`,
    headers: {
      Authorization: Authorization
    },
  };
  return axios(header)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err && err.response && (err.response.status === 400 || err.response.status === 500)) {
        message.info(err.response.data.message);
      }
    });
};